const config = {
  dev: {
    apiBaseURL: 'http://localhost:8000',
  },
  prod: {
    apiBaseURL: 'https://api.repact.cmevo.com',
  },
};

export default process.env.NODE_ENV === 'production' ? config.prod : config.dev;
